
import router from '@/router';
import UserRow from '@/components/UserRow.vue';
import newProjectHelper from '../NewProjectHelper';

export default {
  name: 'CandidatesModal',

  components: {
    UserRow,
  },

  props: {
    candidates: {
      type: Array,
      default: (): unknown[] => [],
    },
    parentScope: {
      type: Object,
      default: (): Record<string, never> => ({}),
    },
  },

  data(): Record<string, unknown> {
    return {
      router: router,
      candidatesSelectedFilter: 'neverAssessed',
      candidatesFilters: ['neverAssessed', 'alreadyAssessed', 'all'],
      newProjectHelper: newProjectHelper,
      candidatesList: [],
    };
  },

  computed: {
    isAssessorPlus(): boolean {
      return localStorage.getItem('roleType') === 'assessorPlus';
    },

    selectedCandidates(): unknown {
      return this.parentScope.selectedCandidates;
    },

    atLeastOneCandidateSelected(): boolean {
      return this.selectedCandidates.length && this.candidatesList.length;
    },
  },

  watch: {
    candidates(newVal: unknown[]): void {
      this.allCandidates = newVal;
      this.candidatesList = this.getFilteredCandidates(this.candidatesSelectedFilter);
    },

    candidatesSelectedFilter(newVal: unknown): void {
      this.candidatesList = this.getFilteredCandidates(newVal);
    },
  },

  created(): void {
    this.allCandidates = this.candidates;
    this.candidatesList = this.getFilteredCandidates(this.candidatesSelectedFilter);
  },

  methods: {
    closeCandidatesModal(): void {
      this.selectedCandidates.forEach((candId: string) => {
        localStorage.removeItem(candId);
      });

      this.$emit('closeCandidatesModal');
    },

    getFilteredCandidates(filter: string): unknown {
      let filteredCandidates = [];

      if (filter === 'neverAssessed') {
        filteredCandidates = this.allCandidates.filter(
          (cand: { assessment_requests: string | unknown[] }) => {
            return !cand.assessment_requests.length;
          },
        );
      }
      if (filter === 'alreadyAssessed') {
        filteredCandidates = this.allCandidates.filter(
          (cand: { assessment_requests: string | unknown[] }) => {
            return cand.assessment_requests.length;
          },
        );
      }
      if (filter === 'all') {
        filteredCandidates = this.allCandidates.map((cand: unknown) => {
          return cand;
        });
      }

      return filteredCandidates;
    },

    closeCandidatesModalWithDelay(): void {
      setTimeout(() => {
        this.closeCandidatesModal();
      }, 250);
    },
  },
};
